import { tWithKeyAttr as t } from "../../../i18nHelper";
import changePasswordPopupStyles from "./changePasswordSuccessPopup.module.css";
import venchyImg from "../../../images/questionnaire_doctor.png";


const getPopupContent = (type: string) => {
  switch (type) {
    case "password":
      return {
        title: t("CHANGE_PASSWORD_SUCCESS_TITLE"),
        message: t("CHANGE_PASSWORD_SUCCESS_MESSAGE"),
      };
    case "avatar":
      return {
        title: t("CHANGE_AVATAR_SUCCESS_TITLE"),
        message: t("CHANGE_AVATAR_SUCCESS_MESSAGE"),
      };
    case "video":
      return {
        title: t("CHANGE_VIDEO_SUCCESS_TITLE"),
        message: t("CHANGE_VIDEO_SUCCESS_MESSAGE"),
      };
    case "delete-avatar":
      return {
        title: t("DELETE_AVATAR_SUCCESS_TITLE"),
        message: t("DELETE_AVATAR_SUCCESS_MESSAGE"),
      };
    case "delete-video":
      return {
        title: t("DELETE_VIDEO_SUCCESS_TITLE"),
        message: t("DELETE_VIDEO_SUCCESS_MESSAGE"),
      };
    default:
      return {
        title: t("DEFAULT_SUCCESS_TITLE"),
        message: t("DEFAULT_SUCCESS_MESSAGE"),
      };
  }
};
interface ChangePasswordSuccessPopupProps {
  onClose: () => void;
  type?: string;

}

function ChangePasswordSuccessPopup({
  onClose,
  type = "password",
}: ChangePasswordSuccessPopupProps) {
  const { title, message } = getPopupContent(type);
  return (
    <article className={changePasswordPopupStyles.popup}>
      <h2 className={changePasswordPopupStyles.popup__title}>
        {title}
      </h2>
      <p className={changePasswordPopupStyles.popup__text}>
        {message}
      </p>
      <img
        src={venchyImg}
        alt={t("IMAGE_ALT_VENCHY")}
        className={changePasswordPopupStyles.popup__img}
      />
      <button
        className={`button hover ${changePasswordPopupStyles.popup__btn}`}
        onClick={onClose}
      >
         {t("SUCCESS_CONFIRM_BUTTON")}
      </button>
    </article>
  );
}

export default ChangePasswordSuccessPopup;
